
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phone/welcome",
      function () {
        return require("private-next-pages/phone/welcome/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phone/welcome"])
      });
    }
  